import React, { useEffect, useState, useCallback, useContext } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import MobileContext from "../../context/mobile";

import Header from "components/ect/Header";
import MenuBar from "components/ect/MenuBar";
import PageTitle from "../ect/PageTitle";
import MyPageMenu from "./MyPageMenu";
import Footer from "components/ect/Footer";
import Paging from "components/ect/Paging";
import BottomNavigation from "components/ect/BottomNavigation";

import MyEventReservListItem from "./my-page-template/MyEventReservListItem";
import MyPlaceReservListItem from "./my-page-template/MyPlaceReservListItem";

const UserReservView = () => {
  const { state } = useContext(MobileContext);

  const history = useHistory();

  const [curEventPage, setCurEventPage] = useState(1);
  const [curPlacePage, setCurPlacePage] = useState(1);
  const getCurEventPage = (pageNum) => {
    setCurEventPage(pageNum);
  };
  const getCurPlacePage = (pageNum) => {
    setCurPlacePage(pageNum);
  };

  const [totalEventRows, setTotalEventRows] = useState(0);
  const [totalPlaceRows, setTotalPlaceRows] = useState(0);

  const [eventReservs, setEventReservs] = useState([]);
  const [placeReservs, setPlaceReservs] = useState([]);

  const deleteEventReserv = (rId) => {
    deleteReserv(rId, "event");
  };

  const deletePlaceReserv = (rId) => {
    deleteReserv(rId, "place");
  };

  const deleteReserv = async (rId, type) => {
    const url = `${process.env.REACT_APP_USER_SERVICE}/api/admin/reserve/${rId}`;

    try {
      const res = await axios.delete(url);

      if (res.status === 200) {
        if (type === "event") {
          getReservEventList();
        } else {
          getReservPlaceList();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getImage = (images) => {
    if (images.length > 0) {
      return JSON.parse(images)[0].url;
    } else {
      return null;
    }
  };

  const getReservEventList = useCallback(async () => {
    const url = `${
      process.env.REACT_APP_USER_SERVICE
    }/api/admin/reserve/event/user/${window.sessionStorage.getItem("userid")}`;

    try {
      const res = await axios.get(url, {
        params: {
          page: curEventPage,
          count: 5,
        },
      });

      if (res.status === 200) {
        const { totalRows, data } = res.data;

        setTotalEventRows(totalRows);

        let ary = [];
        for (let i = 0; i < data.length; i++) {
          ary.push({
            eventInfo: {
              id: data[i].eventId,
              imgSrc: getImage(data[i].images),
              category: data[i].eventType,
              title: data[i].name,
              period: {
                start: data[i].openDate,
                end: data[i].closeDate,
              },
              placeName: data[i].location,
              like: data[i].isLike === 1 ? true : false,
            },
            reservInfo: {
              id: data[i].id,
              userId: data[i].createUid,
              date: data[i].reserveDate,
              name: data[i].userName,
              content: data[i].userMemo,
              tel: data[i].userPhone,
            },
          });
        }

        setEventReservs(ary);
      }
    } catch (e) {
      console.log(e);
    }
  }, [curEventPage]);

  const getReservPlaceList = useCallback(async () => {
    const url = `${
      process.env.REACT_APP_USER_SERVICE
    }/api/admin/reserve/space/user/${window.sessionStorage.getItem("userid")}`;

    try {
      const res = await axios.get(url, {
        params: {
          page: curPlacePage,
          count: 5,
        },
      });

      if (res.status === 200) {
        const { totalRows, data } = res.data;

        setTotalPlaceRows(totalRows);

        let ary = [];
        for (let i = 0; i < data.length; i++) {
          ary.push({
            placeInfo: {
              id: data[i].spaceId,
              imgSrc: getImage(data[i].images),
              category: data[i].spaceType,
              title: data[i].name,
              address: data[i].address1 + " " + data[i],
            },
            reservInfo: {
              id: data[i].id,
              userId: data[i].createUid,
              date: data[i].reserveDate,
              name: data[i].userName,
              content: data[i].userMemo,
              tel: data[i].userPhone,
            },
          });
        }

        setPlaceReservs(ary);
      }
    } catch (e) {
      console.log(e);
    }
  }, [curPlacePage]);

  useEffect(() => {
    const userid = window.sessionStorage.getItem("userid");
    const token = window.sessionStorage.getItem("token");

    if (
      userid === null ||
      userid === undefined ||
      token === null ||
      token === undefined
    ) {
      alert("로그인 후에 이용하실 수 있습니다. ");
      history.push("/common/log-in");
    }

    getReservEventList();
    getReservPlaceList();
  }, [getReservEventList, getReservPlaceList, history]);

  return (
    <div id="container">
      <Header />
      <MenuBar />
      <PageTitle pageTitle="프로필" />

      <section className="explore">
        <div className="container">
          <div className="row">
            <MyPageMenu />

            <div className="col-lg-10">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title-sm">
                    <h2 className="listing-detail__content-title">
                      문화행사 예약 신청 ({totalEventRows}건)
                    </h2>
                    <hr />
                  </div>

                  <div className="explore__box">
                    {eventReservs.map((eventReserv) => (
                      <MyEventReservListItem
                        eventReserv={eventReserv}
                        deleteEventReserv={deleteEventReserv}
                        key={eventReserv.reservInfo.id}
                      />
                    ))}

                    <Paging
                      pageNum={curEventPage}
                      getCurPage={getCurEventPage}
                      onePage={5}
                      all={totalEventRows}
                    />
                  </div>

                  <div className="section-title-sm">
                    <h2 className="listing-detail__content-title">
                      예약 신청한 문화공간 ({totalPlaceRows}건)
                    </h2>
                    <hr />
                  </div>
                  <div className="explore__box">
                    {placeReservs.map((placeReserv) => (
                      <MyPlaceReservListItem
                        placeReserv={placeReserv}
                        deletePlaceReserv={deletePlaceReserv}
                      />
                    ))}

                    <Paging
                      pageNum={curPlacePage}
                      getCurPage={getCurPlacePage}
                      onePage={5}
                      all={totalPlaceRows}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {state.isMobile ? <BottomNavigation /> : ""}
      <Footer />
    </div>
  );
};

export default UserReservView;
